import environment from "environment";
import HttpErrorResponseModel from "models/HttpErrorResponseModel";
import EffectUtility from "utilities/EffectUtility";
import SearchModel from "./models/SearchModel";

export interface CercaHeaderRequest {
    searchText?: string;
    totRecords?: number;
}

export default class CercaHeaderEffect {
    public static async search(request: CercaHeaderRequest): Promise<SearchModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.searchEntities;
        return EffectUtility.getToModel<SearchModel>(SearchModel, endpoint, request);
    }
}
